if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.buyNow = this.querySelector('[data-buy-now]');
        if (this.buyNow) this.buyNow.addEventListener('click', this.onBuyNow.bind(this));
        this.initBuyTotal();
        this.initAddons();
      }

      // Buy Now: same add as the form (free pack included when it qualifies), then checkout.
      onBuyNow(evt) {
        evt.preventDefault();
        if (this.buyNow.disabled || this.buyNow.getAttribute('aria-disabled') === 'true') return;
        if (this.upgradeGate(() => this.onBuyNow(evt))) return;
        this.handleErrorMessage();
        this.buyNow.setAttribute('aria-disabled', true);
        this.buyNow.classList.add('loading');
        this.buyNow.querySelector('.loading__spinner')?.classList.remove('hidden');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = this.withFreeGift(new FormData(this.form));
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.buyNow.removeAttribute('aria-disabled');
              this.buyNow.classList.remove('loading');
              this.buyNow.querySelector('.loading__spinner')?.classList.add('hidden');
              return;
            }
            window.location = '/checkout';
          })
          .catch((e) => {
            console.error(e);
            this.buyNow.removeAttribute('aria-disabled');
            this.buyNow.classList.remove('loading');
          });
      }

      // Line under the button: "$40.94 total with shipping. Switch to the 6 Pack for $19.05 more: ..."
      initBuyTotal() {
        const el = this.querySelector('[data-buy-total]');
        if (!el) return;
        let map;
        try {
          map = JSON.parse(el.dataset.map);
        } catch (e) {
          return;
        }
        const threshold = +el.dataset.threshold;
        const ship = +el.dataset.ship;
        const bags = +el.dataset.bags || 7;
        const nextName = el.dataset.nextName || '6 Pack';
        const money = (cents) => (typeof Shopify !== 'undefined' && Shopify.formatMoney ? Shopify.formatMoney(cents, window.money_format || '${{amount}}') : '$' + (cents / 100).toFixed(2));
        // Subscribe and Save (Appstle radios named selling_plan): the per-delivery price comes
        // from the product JSON's selling_plan_allocations; subscriptions ship free and get no
        // free pack, so the one-time line would be wrong. Fetched once, on first need.
        let productJson = null;
        const planId = () => {
          const r = this.form.querySelector('input[name="selling_plan"]:checked');
          if (r) return String(r.value || '');
          const any = this.form.querySelector('input[name="selling_plan"]');
          if (any) return String(any.value || '');
          // The Appstle widget renders after us; until it does, trust the URL (?selling_plan=... preselects it).
          return new URLSearchParams(window.location.search).get('selling_plan') || '';
        };
        const renderPlan = (variantId, plan) => {
          const show = () => {
            const pv = productJson && productJson.variants.find((x) => String(x.id) === String(variantId));
            const alloc = pv && (pv.selling_plan_allocations || []).find((a) => String(a.selling_plan_id) === plan);
            el.innerHTML = alloc
              ? `<strong>${money(alloc.price)} per delivery.</strong> Ships free. Skip or cancel any time.`
              : '<strong>Subscription.</strong> Ships free. Skip or cancel any time.';
          };
          if (productJson) return show();
          const handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
          if (!handle) return show();
          fetch(`/products/${handle}.js`).then((r) => r.json()).then((j) => { productJson = j; if (planId() === plan) show(); }).catch(show);
        };
        const render = (variantId) => {
          const v = map[variantId];
          if (!v) { el.innerHTML = ''; return; }
          const plan = planId();
          if (plan) return renderPlan(variantId, plan);
          const shipCost = v.price >= threshold ? 0 : ship;
          const total = v.price + shipCost;
          if (v.qualifies) {
            // Same-colour free pack sold out: buy-buttons.liquid swapped in another colour; say so.
            let alt = null;
            try {
              alt = this.dataset.freeGiftAlt ? JSON.parse(this.dataset.freeGiftAlt)[variantId] : null;
            } catch (e) {}
            const note = alt && alt.gift ? ` Your free pack ships in ${alt.gift} while ${alt.own} restocks.` : '';
            el.innerHTML = `<strong>${money(total)} total.</strong> Free pack and free shipping included.${note}`;
            return;
          }
          let html = `<strong>${money(total)} total${shipCost ? ' with shipping' : ''}.</strong>`;
          if (v.next && v.nextPrice) {
            const nextShip = v.nextPrice >= threshold ? 0 : ship;
            const diff = v.nextPrice + nextShip - total;
            const moreBags = (v.nextPacks - v.packs) * bags + bags;
            html += ` <a href="#" class="buy-total__switch" data-switch-to="${v.next}">Switch to the ${nextName}</a> for ${money(diff)} more: ${moreBags} more bags, a free pack, and shipping is free.`;
          }
          el.innerHTML = html;
        };
        render(this.variantIdInput.value);
        this.form.addEventListener('change', (ev) => {
          if (ev.target && ev.target.name === 'selling_plan') render(this.variantIdInput.value);
        });
        // Re-render once the widget's radios exist (they decide the plan from then on).
        if (typeof MutationObserver !== 'undefined' && !this.form.querySelector('input[name="selling_plan"]')) {
          const mo = new MutationObserver(() => {
            if (this.form.querySelector('input[name="selling_plan"]')) { mo.disconnect(); render(this.variantIdInput.value); }
          });
          mo.observe(this.form, { childList: true, subtree: true });
          setTimeout(() => mo.disconnect(), 15000);
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const v = event.data && event.data.variant;
            if (v && event.data.sectionId === this.dataset.sectionId) render(String(v.id));
          });
        }
        el.addEventListener('click', (e) => {
          const link = e.target.closest('[data-switch-to]');
          if (!link) return;
          e.preventDefault();
          const packName = nextName;
          const radio = document.querySelector(`variant-selects input[type="radio"][data-pack-value="${packName}"]`);
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.upgradeGate(() => this.onSubmitHandler(evt))) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = this.withFreeGift(formData);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      // 3 Pack upgrade step (2026-10-12): when the picked pack does not get the free pack and a same-colour
      // 6 Pack exists, the first Buy Now / Add to Cart / sticky-bar tap opens a one-tap sheet before the add.
      // Data comes from the buy-total map rendered in buy-buttons.liquid (price, packs, next, nextPrice).
      // Shown once per session; skipped for subscriptions. The outcome is saved as cart attribute upsell_3to6.
      upgradeOffer() {
        const el = this.querySelector('[data-buy-total]');
        if (!el || !el.dataset.map) return null;
        let map;
        try {
          map = JSON.parse(el.dataset.map);
        } catch (e) {
          return null;
        }
        const v = map[this.variantIdInput.value];
        if (!v || v.qualifies || !v.next || !v.nextPrice) return null;
        const plan = this.form.querySelector('[name="selling_plan"]');
        if (plan && plan.value) return null;
        try {
          if (sessionStorage.getItem('ts_up_shown')) return null;
        } catch (e) {}
        return {
          v,
          threshold: +el.dataset.threshold,
          ship: +el.dataset.ship,
          bags: +el.dataset.bags || 7,
          nextName: el.dataset.nextName || '6 Pack',
        };
      }

      upgradeGate(resume) {
        if (this.upgradePass) {
          this.upgradePass = false;
          return false;
        }
        const offer = this.upgradeOffer();
        if (!offer) return false;
        try {
          sessionStorage.setItem('ts_up_shown', '1');
        } catch (e) {}
        this.showUpgradeSheet(offer).then((choice) => {
          if (choice === 'dismissed') {
            this.setCartAttributes({ upsell_3to6: 'dismissed' });
            return;
          }
          if (choice === 'accepted') {
            this.variantIdInput.value = String(offer.v.next);
            const radio = document.querySelector(`variant-selects input[type="radio"][data-pack-value="${offer.nextName}"]`);
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          this.setCartAttributes({ upsell_3to6: choice }).finally(() => {
            this.upgradePass = true;
            resume();
          });
        });
        return true;
      }

      setCartAttributes(attributes) {
        return fetch(`${routes.cart_update_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
        }).catch(() => {});
      }

      showUpgradeSheet({ v, threshold, ship, bags, nextName }) {
        const money = (cents) =>
          typeof Shopify !== 'undefined' && Shopify.formatMoney
            ? Shopify.formatMoney(cents, window.money_format || '${{amount}}')
            : '$' + (cents / 100).toFixed(2);
        const total = v.price + (v.price >= threshold ? 0 : ship);
        const nextTotal = v.nextPrice + (v.nextPrice >= threshold ? 0 : ship);
        const curName = `${v.packs} Pack`;
        const curBags = v.packs * bags;
        const nextBags = v.nextPacks * bags + bags;
        const sheet = document.createElement('div');
        sheet.className = 'ts-up';
        sheet.innerHTML = `
          <div class="ts-up__backdrop" data-up="dismissed"></div>
          <div class="ts-up__panel" role="dialog" aria-modal="true" aria-labelledby="TsUpTitle">
            <button type="button" class="ts-up__close" data-up="dismissed" aria-label="Close">&times;</button>
            <p class="ts-up__eyebrow">Most people pick the ${nextName}</p>
            <h2 class="ts-up__title" id="TsUpTitle">Make it the ${nextName} for ${money(nextTotal - total)} more</h2>
            <ul class="ts-up__list">
              <li>${nextBags} bags instead of ${curBags}</li>
              <li>A free pack included</li>
              <li>Free shipping</li>
            </ul>
            <button type="button" class="button button--full-width button--primary ts-up__yes" data-up="accepted">Upgrade to the ${nextName} &middot; ${money(nextTotal)}</button>
            <button type="button" class="ts-up__no" data-up="declined">Keep the ${curName} &middot; ${money(total)} with shipping</button>
          </div>`;
        document.body.appendChild(sheet);
        document.body.classList.add('ts-up-open');
        requestAnimationFrame(() => sheet.classList.add('is-open'));
        const yes = sheet.querySelector('.ts-up__yes');
        if (yes) yes.focus({ preventScroll: true });
        return new Promise((resolve) => {
          const done = (choice) => {
            document.removeEventListener('keydown', onKey);
            sheet.classList.remove('is-open');
            document.body.classList.remove('ts-up-open');
            setTimeout(() => sheet.remove(), 200);
            resolve(choice);
          };
          const onKey = (e) => {
            if (e.key === 'Escape') done('dismissed');
          };
          document.addEventListener('keydown', onKey);
          sheet.addEventListener('click', (e) => {
            const t = e.target.closest('[data-up]');
            if (t) done(t.dataset.up);
          });
        });
      }

      // Free pack offer (buy-buttons "free_gift_enabled"): when the chosen variant
      // qualifies, add the same-color free pack in the same request so the
      // automatic BXGY discount can make it $0. Subscriptions and line-item
      // properties keep the plain single-item add.
      withFreeGift(formData) {
        // Add-ons (buy-addons.liquid, 2026-10-19): checked accessories ride along in the same request.
        // A colour pill inside the row swaps the checkbox value before we read it.
        const addons = [];
        this.querySelectorAll('.buy-addons__row').forEach((row) => {
          const box = row.querySelector('input[name="addon_variant"]');
          const pick = row.querySelector('.buy-addons__pick.is-on');
          if (box && box.checked) addons.push(pick ? pick.dataset.addonVariant : box.value);
        });
        formData.delete('addon_variant');

        let giftId = null;
        if (this.dataset.freeGift && !formData.get('selling_plan') && ![...formData.keys()].some((key) => key.startsWith('properties['))) {
          try {
            giftId = JSON.parse(this.dataset.freeGift)[formData.get('id')] || null;
          } catch (e) {
            giftId = null;
          }
        }
        if (!giftId && !addons.length) return formData;

        const quantity = formData.get('quantity') || '1';
        const body = new FormData();
        let n = 0;
        body.append(`items[${n}][id]`, formData.get('id'));
        body.append(`items[${n}][quantity]`, quantity);
        if (formData.get('selling_plan')) body.append(`items[${n}][selling_plan]`, formData.get('selling_plan'));
        n += 1;
        if (giftId) {
          body.append(`items[${n}][id]`, giftId);
          body.append(`items[${n}][quantity]`, quantity);
          n += 1;
        }
        addons.forEach((id) => {
          body.append(`items[${n}][id]`, id);
          body.append(`items[${n}][quantity]`, '1');
          n += 1;
        });
        ['sections', 'sections_url'].forEach((key) => {
          if (formData.has(key)) body.append(key, formData.get(key));
        });
        return body;
      }

      // Colour pills inside an add-on row: one click picks the colour and ticks the row.
      initAddons() {
        const box = this.querySelector('[data-buy-addons]');
        if (!box) return;
        box.addEventListener('click', (e) => {
          const pick = e.target.closest('.buy-addons__pick');
          if (!pick) return;
          e.preventDefault();
          const row = pick.closest('.buy-addons__row');
          row.querySelectorAll('.buy-addons__pick').forEach((b) => b.classList.toggle('is-on', b === pick));
          const check = row.querySelector('input[name="addon_variant"]');
          check.value = pick.dataset.addonVariant;
          check.checked = true;
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
